// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════════
   PaginatedTable.css  —  CPV design-system-aligned table component
   ═══════════════════════════════════════════════════════════════════ */

/* ── Wrapper ─────────────────────────────────────────────────────── */
.cpt__wrap {
  width: 100%;
  background: #ffffff;
  border-radius: 28px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ── Table Scroll Wrapper ────────────────────────────────────────── */
.cpt__table-scroll {
  width: 100%;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 320px);
}

.cpt__table-scroll::-webkit-scrollbar {
  width: 6px;
}
.cpt__table-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
}
.cpt__table-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.cpt__table-scroll::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* ── Header row ──────────────────────────────────────────────────── */
.cpt__header {
  display: grid;
  /* column-gap: 1.25rem; */
  padding: 0.7rem 0.75rem 0.7rem 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 10;
}

.cpt__header-cell {
  font-size: 0.65rem;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 0.35rem 0;
}

/* ── Body ────────────────────────────────────────────────────────── */
.cpt__body {
  display: flex;
  flex-direction: column;
}

/* ── Data row ────────────────────────────────────────────────────── */
.cpt__row {
  display: grid;
  /* column-gap: 1.25rem; */
  padding: 0.75rem;
  border-bottom: 1px solid #f1f5f9;
  align-items: center;
  border-radius: 8px;
  transition: background 0.12s;
}

.cpt__row:last-child {
  border-bottom: none;
}

.cpt__row:hover {
  background: #f8fafc;
}

/* ── Cell ────────────────────────────────────────────────────────── */
.cpt__cell {
  font-size: 0.84rem;
  color: #475569;
  font-weight: 500;
  /* Truncate overflowing text; padding-right keeps text away from the column edge */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 0.5rem;
  min-width: 0;
}

/* ── Empty / loader state ────────────────────────────────────────── */
.cpt__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  color: #94a3b8;
  font-size: 0.85rem;

  /* keep the card shell visible even when empty */
  width: 100%;
  background: #ffffff;
  border-radius: 28px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.04);
}

/* ── Pagination loader (between pages) ───────────────────────────── */
.cpt__page-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  width: 100%;
}

/* ── Spinner ─────────────────────────────────────────────────────── */
.cpt__spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e2e8f0;
  border-top-color: #3b6ef6;
  border-radius: 50%;
  animation: cpt-spin 0.75s linear infinite;
}

@keyframes cpt-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ── Pagination footer ───────────────────────────────────────────── */
.cpt__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0.75rem 0.5rem;
  border-top: 1px solid #f1f5f9;
  margin-top: auto;
}

.cpt__pagination-info {
  font-size: 0.78rem;
  color: #64748b;
  font-weight: 500;
}

.cpt__pagination-btns {
  display: flex;
  gap: 0.4rem;
}

.cpt__pagination-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  line-height: 1;
  transition:
    border-color 0.15s,
    background 0.15s;
}

.cpt__pagination-btn:hover:not(:disabled) {
  border-color: #94a3b8;
  background: #f8fafc;
}

.cpt__pagination-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* ── Responsive: hide less-important columns on small screens ─────── */
@media (max-width: 640px) {
  .cpt__header,
  .cpt__row {
    /* Let individual consumers override grid-template-columns for mobile
       by adding a .cpt--mobile-cols utility class or inline style.
       This default collapses to a single-column stack as fallback. */
    font-size: 0.78rem;
  }

  .cpt__cell {
    white-space: normal; /* allow wrapping on mobile */
  }
}

/* ═══ DARK THEME — CustomerPaginatedTable ═══ */
.dark .cpt__wrap {
  background: #1e293b;
  border-color: #334155;
}
.dark .cpt__table-scroll::-webkit-scrollbar-track { background: #0f172a; }
.dark .cpt__table-scroll::-webkit-scrollbar-thumb { background: #334155; }

.dark .cpt__header {
  background: #0f172a;
  border-bottom-color: #334155;
}
.dark .cpt__header-cell { color: #64748b; }

.dark .cpt__row { border-bottom-color: #1e293b; }
.dark .cpt__row:hover { background: #243043; }

.dark .cpt__cell { color: #94a3b8; }

.dark .cpt__empty {
  background: #1e293b;
  border-color: #334155;
  color: #64748b;
}

.dark .cpt__pagination { border-top-color: #334155; }
.dark .cpt__pagination-info { color: #64748b; }
.dark .cpt__pagination-btn {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .cpt__pagination-btn:hover:not(:disabled) {
  border-color: #475569;
  background: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/CustomerV2Preview/Component/CustomComponent/CustomerPaginatedTable.css"],"names":[],"mappings":"AAAA;;wEAEwE;;AAExE,uEAAuE;AACvE;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,yBAAyB;EACzB,sCAAsC;EACtC,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kFAAkF;EAClF,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;;EAElB,gDAAgD;EAChD,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;EACE;;IAEE;;qEAEiE;IACjE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB,EAAE,6BAA6B;EACpD;AACF;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,oDAAoD,mBAAmB,EAAE;AACzE,oDAAoD,mBAAmB,EAAE;;AAEzE;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,0BAA0B,cAAc,EAAE;;AAE1C,kBAAkB,4BAA4B,EAAE;AAChD,wBAAwB,mBAAmB,EAAE;;AAE7C,mBAAmB,cAAc,EAAE;;AAEnC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,yBAAyB,yBAAyB,EAAE;AACpD,8BAA8B,cAAc,EAAE;AAC9C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":["/* ═══════════════════════════════════════════════════════════════════\n   PaginatedTable.css  —  CPV design-system-aligned table component\n   ═══════════════════════════════════════════════════════════════════ */\n\n/* ── Wrapper ─────────────────────────────────────────────────────── */\n.cpt__wrap {\n  width: 100%;\n  background: #ffffff;\n  border-radius: 28px;\n  border: 1px solid #f1f5f9;\n  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Table Scroll Wrapper ────────────────────────────────────────── */\n.cpt__table-scroll {\n  width: 100%;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: calc(100vh - 320px);\n}\n\n.cpt__table-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n.cpt__table-scroll::-webkit-scrollbar-track {\n  background: #f1f5f9;\n}\n.cpt__table-scroll::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n.cpt__table-scroll::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* ── Header row ──────────────────────────────────────────────────── */\n.cpt__header {\n  display: grid;\n  /* column-gap: 1.25rem; */\n  padding: 0.7rem 0.75rem 0.7rem 0.75rem;\n  border-bottom: 1px solid #e2e8f0;\n  position: sticky;\n  top: 0;\n  background: #ffffff;\n  z-index: 10;\n}\n\n.cpt__header-cell {\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: #94a3b8;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  padding: 0.35rem 0;\n}\n\n/* ── Body ────────────────────────────────────────────────────────── */\n.cpt__body {\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Data row ────────────────────────────────────────────────────── */\n.cpt__row {\n  display: grid;\n  /* column-gap: 1.25rem; */\n  padding: 0.75rem;\n  border-bottom: 1px solid #f1f5f9;\n  align-items: center;\n  border-radius: 8px;\n  transition: background 0.12s;\n}\n\n.cpt__row:last-child {\n  border-bottom: none;\n}\n\n.cpt__row:hover {\n  background: #f8fafc;\n}\n\n/* ── Cell ────────────────────────────────────────────────────────── */\n.cpt__cell {\n  font-size: 0.84rem;\n  color: #475569;\n  font-weight: 500;\n  /* Truncate overflowing text; padding-right keeps text away from the column edge */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 0.5rem;\n  min-width: 0;\n}\n\n/* ── Empty / loader state ────────────────────────────────────────── */\n.cpt__empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 120px;\n  color: #94a3b8;\n  font-size: 0.85rem;\n\n  /* keep the card shell visible even when empty */\n  width: 100%;\n  background: #ffffff;\n  border-radius: 28px;\n  border: 1px solid #f1f5f9;\n  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.04);\n}\n\n/* ── Pagination loader (between pages) ───────────────────────────── */\n.cpt__page-loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  width: 100%;\n}\n\n/* ── Spinner ─────────────────────────────────────────────────────── */\n.cpt__spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #3b6ef6;\n  border-radius: 50%;\n  animation: cpt-spin 0.75s linear infinite;\n}\n\n@keyframes cpt-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ── Pagination footer ───────────────────────────────────────────── */\n.cpt__pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 0.75rem 0.5rem;\n  border-top: 1px solid #f1f5f9;\n  margin-top: auto;\n}\n\n.cpt__pagination-info {\n  font-size: 0.78rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.cpt__pagination-btns {\n  display: flex;\n  gap: 0.4rem;\n}\n\n.cpt__pagination-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  line-height: 1;\n  transition:\n    border-color 0.15s,\n    background 0.15s;\n}\n\n.cpt__pagination-btn:hover:not(:disabled) {\n  border-color: #94a3b8;\n  background: #f8fafc;\n}\n\n.cpt__pagination-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n/* ── Responsive: hide less-important columns on small screens ─────── */\n@media (max-width: 640px) {\n  .cpt__header,\n  .cpt__row {\n    /* Let individual consumers override grid-template-columns for mobile\n       by adding a .cpt--mobile-cols utility class or inline style.\n       This default collapses to a single-column stack as fallback. */\n    font-size: 0.78rem;\n  }\n\n  .cpt__cell {\n    white-space: normal; /* allow wrapping on mobile */\n  }\n}\n\n/* ═══ DARK THEME — CustomerPaginatedTable ═══ */\n.dark .cpt__wrap {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .cpt__table-scroll::-webkit-scrollbar-track { background: #0f172a; }\n.dark .cpt__table-scroll::-webkit-scrollbar-thumb { background: #334155; }\n\n.dark .cpt__header {\n  background: #0f172a;\n  border-bottom-color: #334155;\n}\n.dark .cpt__header-cell { color: #64748b; }\n\n.dark .cpt__row { border-bottom-color: #1e293b; }\n.dark .cpt__row:hover { background: #243043; }\n\n.dark .cpt__cell { color: #94a3b8; }\n\n.dark .cpt__empty {\n  background: #1e293b;\n  border-color: #334155;\n  color: #64748b;\n}\n\n.dark .cpt__pagination { border-top-color: #334155; }\n.dark .cpt__pagination-info { color: #64748b; }\n.dark .cpt__pagination-btn {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .cpt__pagination-btn:hover:not(:disabled) {\n  border-color: #475569;\n  background: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
